import classNames from 'classnames'

import { Menu } from 'dashboard/components/Header'
import styles from './styles.module.scss'

const MainHeader = ({ routes }) => (
    <div className={classNames('container', styles.npsContentHeader)}>
        <div className="dashboard-container mb-0">
            <div className="dashboard-header pt-0 mb-0">
                <div className="dashboard-inner-container">
                    <Menu items={routes} />
                </div>
            </div>
        </div>
    </div>
)

export default MainHeader
